import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export const Container = styled.div`
    width: 100%;
    padding: 1rem;
    max-width: 20.625rem;
    min-width: 20.625rem;
    min-height: 20.625rem;
    max-height: 20.625rem;

    display: flex;
    flex-direction: column;
    overflow: hidden;

    border-radius: 0.75rem;
    background-color: #f8f8f9;
    border: 0.3rem solid #f8f8f9;

    position: relative;
    
    ::-webkit-scrollbar{
      display: none;
    }

    @media (max-width: 1320px) {
        width: 100%;
        max-width: 100%;
    }
    
    @media (max-width: 1070px) {
        height: 100%;
        max-width: 100%;
    }

    @media (max-width: 768px) {
        width: 100%;
        max-width: 100%;
        min-height: auto;
        max-height: none;
        overflow: visible;
    }
`;

export const CardsScroll = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: scroll;

    ::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: 768px) {
        flex-direction: row;
        flex-wrap: nowrap;
        overflow-y: hidden;
        overflow-x: scroll;
        gap: 0.75rem;
        padding-bottom: 0.5rem;
    }

    @media (max-width: 479px) {
       min-width: auto;
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    justify-content: space-between;
`;

export const ViewAll = styled.a`
    gap: 0.2rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    
    cursor: pointer;
    
    > img{
        width: 16px;
        height: auto;
      display: flex;
    }
    
    > p{
      display: flex;
      cursor: pointer;
    }
`;

export const CreateEventButton = styled.button`
    bottom: 0;
    z-index: 4;
    width: 100%;
    height: 3rem;
    padding: 0.75rem;
    position: sticky;

    display: flex;
    align-items: center;
    justify-content: center;
    
    border: none;
    cursor: pointer;
    border-radius: 0.5rem;
    background-color: #e9f1ff;
    
    &:hover {
      background-color: #d8e9ff;
    }
`;

export const PlusIcon = styled.img`
    width: 1.4rem;
    
    margin-right: 0.5rem;
`;

export const EventCard = styled.div`
    padding: 0.8rem;
    position: relative;

    display: flex;
    align-items: flex-end;
    margin-bottom: 0.75rem;
    justify-content: space-between;

    border-radius: 0.5rem;
    background-color: white;

    cursor: pointer;

    @media (max-width: 768px) {
        width: 85%;
        min-width: 85%;
        max-width: 85%;
        flex-shrink: 0;
        margin-bottom: 0;
    }
`;

export const EventInfo = styled.div`
    width: auto;
    height: auto;

    gap: 0.3rem;
    display: flex;
    flex-direction: column; 
`;

export const EventLocation = styled.p`
    padding: 0.5rem;
    max-width: 7.5rem;
    
    gap: 0.2rem;
    display: flex;
    margin: 0 0 0.25rem;
    align-items: center;
    
    border-radius: 999px;
    background-color: #F3F3F5;

    p {
      max-width: 6.25rem;
      
      overflow: hidden;
      white-space: nowrap;
      display: inline-block;
      text-overflow: ellipsis;
      text-transform: uppercase;
    }
    
    @media (max-width: 360px) {
        font-size: 0.47rem;
    }
  
`;

export const EventDate = styled.span`
    color: #888;
    font-size: 0.55rem;
    letter-spacing: 0.1rem;
`;

export const EventActions = styled.div`
    width: auto;
    height: auto;
    
    gap: 0.5rem;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    justify-content: space-around;
`;

export const CropBadge = styled.span`
    padding: 0.4rem 0.5rem;
    
    margin-right: 0.5rem;
    
    color: white;
    font-weight: 700;
    font-size: 0.55rem;
    border-radius: 3rem;
    letter-spacing: 0.1rem;
    background-color: ${theme.colors.gray.Cinza_2};
`;

export const FarmWrapper = styled.div`
    gap: 0.2rem;
    display: flex;
    flex-direction: row;
    
    @media (max-width: 360px) {
        gap: 0;
    }
`;

export const FarmerImage = styled.img`
    width: 1.5rem;
    
    object-fit: cover;
    border-radius: 50%;
`;

export const AnchorWrapper = styled.div`
    display: flex;
    align-items: flex-end;

    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

export const AnchorIcons = styled.a`
  margin-right: 0.75rem;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.7 : 1)};

  > img {
    width: 1rem;
  }
`;

export const CultureCircle = styled.div`
    max-width: 10.6875rem;
    height: auto;
    padding: 4px 8px ;

    display: flex;

    border-radius: 5rem;
    background-color: ${theme.colors.gray.Cinza_2};
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-word;

    >p{
        text-transform: uppercase;
    }
`;

export const ProfileCircle = styled.div`
    width: 24px;
    height: 24px;
    padding: 4px 8px ;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 5rem;
    background-color: #5BB3FF;

    >p{
        text-transform: uppercase;
    }
`;

export const ButtonSaved = styled.button`
    all: unset;
    width: 100%;
    height: 1.5rem;
    padding: 0.75rem 1rem;

    display: flex;
    margin-top: 1rem;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    border-radius: 5rem;
    background-color: ${(props) => props.disabled ? theme.colors.disabled.Fundo_Desabilitado : theme.colors.green.Verde_AgroReceita};

    >p{
        cursor: pointer;
        text-align: center;
        color: ${(props) => props.disabled ? theme.colors.disabled.Desabilitado_Medio : theme.colors.white.Branco};
    }
`;

export const ContainerNewCardRight = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    margin-top: 1.5rem;
    align-items: center;
    justify-content: center;
`;

export const ContainerSavedEvent = styled.div`
    width: 100%;
    height: auto;
    max-width: 26.25rem;

    display: flex;
    margin-top: 2rem;

    border-top: 1px solid ${theme.colors.gray.Cinza_10};
`;

export const InputAndButton = styled.div`
    width: 100%;
    height: auto;
    max-width: 26.25rem;

    gap: 0.5rem;
    display: flex;

    @media (max-width: 479px) {
        align-items: center;
        flex-direction: column;
    }
`;

export const InputButton = styled.button`
    all: unset;

    width: auto;
    height: auto;
    padding: 0.5rem 0.75rem;

    display: flex;
    align-items: center;

    cursor: ${(props => props.disabled ? 'not-allowed' : 'pointer')};


    text-align: center;

    text-transform: uppercase;
    color:  ${(props => props.disabled ? theme.colors.disabled.Desabilitado_Medio : theme.colors.blue.Azul_link)};
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extraBold};
    font-size: ${theme.typography.fontSize.tagLineM};
    line-height: ${theme.typography.lineHeight.tagLineM};
    letter-spacing: ${theme.typography.letterSpacing.normal};
`;

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }

  width: 20px;
  height: 20px;
  position: relative;
  margin: auto;
  margin-top: 50px;
  margin-bottom: 50px;

  background-color: transparent;
  border-top: 1px solid #FFF;
  border-bottom: 1px solid #FFF;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;
`;

export const TextArea = styled.textarea`
    width: 100%;
    height: 8.25rem;
    padding: 0.875rem 1rem 0.875rem 1rem;

    border-radius: 0.5rem;
    border: 1px solid ${props => props.hasError ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_7};

    color: ${theme.colors.gray.Cinza_2};
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.regular};
    font-size: ${theme.typography.fontSize.bodyP};
    line-height: ${theme.typography.lineHeight.bodyP};
    letter-spacing: 0px;

    ::placeholder{
        color: ${theme.colors.gray.Cinza_7};
        font-family: ${theme.typography.fontFamily.primary};
        font-weight: ${theme.typography.fontWeight.regular};
        font-size: ${theme.typography.fontSize.bodyP};
        line-height: ${theme.typography.lineHeight.bodyP};
        letter-spacing: 0px;
    }
`;

export const WrapperNewCardRight = styled.div`
    width: 100%;
    height: auto;
    max-width: 26.25rem;

    gap: 1rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
`;

export const EventTitle = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-word;

  >p{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const NotFound = styled.div`
    width: 100%;
    height: 13rem;

    gap: 0.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    >img{
        width: 100%;
        height: auto;
        max-width: 80px;
    }
`;